const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * SEARCH EVENTS                                                              *
 * -------------                                                              *
 * - Search most serched term clicked                                         *
 * - Search query inserted                                                    *
 * - Search Modal 'may be interested' product clicked                         *
 * - Search Modal 'may be interested' product viewed                          *
 * - Search with no result                                                    *
 * - Search session used                                                      *
 * - Search tooltip loaded/clicked                                            *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Search most serched term clicked
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchMostSearchedClicked,
    (term) => {
      pushEvent(
        createCustomEventGA4('top_search', [['top_search_suggested', term]])
      );
    }
  );

  // Search query inserted
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchQueryInserted,
    (payload) => {
      pushEvent(
        createCustomEventGA4('search', [['search_term', payload.search.query]])
      );
    }
  );

  // Search may be interested product clicked
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchRecommendedProductClicked,
    (payload) => {
      pushEvent(
        createCustomEventGA4('search_may_be_interested', [
          ['type', 'click'],
          ['item', payload.productId],
          ['position', payload.position],
          ['item_list_id', payload.location],
          ['component', payload.componentType],
        ])
      );
    }
  );

  // Search may be interested product viewed
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchRecommendedProductViewed,
    (payload) => {
      pushEvent(
        createCustomEventGA4('search_may_be_interested', [
          ['type', 'impression'],
          ['item', payload.productId],
          ['position', payload.position],
          ['item_list_id', payload.location],
          ['component', payload.componentType],
        ])
      );
    }
  );

  // Search with no result
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.searchReturnedNoResults,
    (payload) => {
      pushEvent(
        createCustomEventGA4('search_without_results', [
          ['keyword', payload.query],
        ])
      );
    }
  );

  // Search session used
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.searchSessionUsed, (type) => {
    pushEvent(
      createCustomEventGA4('search_session', [['search_engine_type', type]])
    );
  });

  // Search tooltip loaded/clicked
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.searchTooltipLoaded, (item) => {
    pushEvent(createCustomEventGA4('search_tooltip', [['item', item]]));
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
